// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageBlock_root__xwsQ3"};